export const validateMantenimientoIcon = (codigo) => {
  const thirdLetter = codigo.substring(2, 3);

  return thirdLetter === 'M';
};
